export const validateRequired = (value: unknown): value is string =>
    typeof value == 'string' && value.length > 0;

export const validateEmail = (value: unknown): value is string =>
    // From https://html.spec.whatwg.org/multipage/forms.html#valid-e-mail-address
    typeof value === 'string' &&
    /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/
        .test(value);